import React, { useState, useRef, useEffect } from "react";
import { useLocation } from 'react-router-dom';
import ModelSelector from "./ModelSelector";
import MultipleChoiceTabs from "./MultipleChoiceTabs";
import { Proyecto } from "api/projectService";

export default function Evaluation() {
    const [showModel, setShowModel] = useState(false);
    const tabsRef = useRef<{ handleTabClick: (index: number) => void }>(null);
    const [tabInicial, setTabInicial] = useState(1);
    const location = useLocation();
    const { project } = location.state || {};

    //console.log("proyecto recibido evaluacion:"+JSON.stringify(project?.originalProject));


    const [inProyecto, setInProyecto] = useState<Proyecto>(() => {
        if (project?.originalProject) {
            //console.log("proyecto recibido evaluacion:"+JSON.stringify(project?.originalProject));
            //console.log("proyecto recibido evaluacion -> Lidera mujer:"+JSON.stringify(project?.originalProject.lideraMujer));
            return {
                nombre: project.originalProject.nombre || "",
                organizacion: project.originalProject.organizacion || "",
                tipoOrganizacion: project.originalProject.tipoOrganizacion || "",
                tipoProyecto: project.originalProject.tipoProyecto || "",
                nombreTipoProyecto: project.originalProject.nombreTipoProyecto || "",
                tipoSector: project.originalProject.tipoSector || "",
                programa: project.originalProject.programa || "",
                nombreContacto: project.originalProject.nombreContacto || "",
                emailContacto: project.originalProject.emailContacto || "",
                descripcion: project.originalProject.descripcion || "",
                idProyecto: project.originalProject.idProyecto || 0,
                nuevaEvaluacion: project.originalProject.nuevaEvaluacion || null,
                evaluaciones: project.originalProject.evaluaciones || [],
                idRegion: project.originalProject.idRegion || "",
                imagenRadar:project.originalProject.imagenRadar,
                lideraMujer: project.originalProject.lideraMujer ,
                financiamiento: project.originalProject.financiamiento,
            };
        } else {
            return {
                nombre: "",
                organizacion: "",
                tipoOrganizacion: "",
                tipoProyecto: 1,
                nombreTipoProyecto: "",
                tipoSector: "",
                programa: "",
                nombreContacto: "",
                emailContacto: "",
                descripcion: "",
                idProyecto: 0,
                nuevaEvaluacion: null,
                evaluaciones: [],
                idRegion:"",
                imagenRadar:"",
                lideraMujer:null,
                financiamiento: []
            };
        }
    });

    //console.log("[Evaluation.tsx] inproyecto:"+JSON.stringify(inProyecto));
    

    // Función que se encarga de cambiar (toggle) el flag
    const handleToggleFlag = (num?: number, inProyecto?: Proyecto) => {

        if (num && inProyecto) {
            setTabInicial(num);
            setInProyecto(inProyecto);
            setShowModel(true);

            return;
        }
        setShowModel(false);
    };

    return (
        <div>
            {showModel ?
                <MultipleChoiceTabs proyecto={inProyecto} tabInicial={tabInicial} onToggleFlag={handleToggleFlag} ref={tabsRef} />
                :
                <ModelSelector proyecto={inProyecto} onToggleFlag={handleToggleFlag} />
            }
        </div>
    );
}